module.exports = __webpack_public_path__ + "media/images/application/template/logos/gallagher-378c991ee4c5b3a63ef71c421b66af3d.png";